import { render, staticRenderFns } from "./details_tabs.vue?vue&type=template&id=f08e66bc&"
import script from "./details_tabs.vue?vue&type=script&lang=js&"
export * from "./details_tabs.vue?vue&type=script&lang=js&"
import style0 from "./details_tabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports